export const getMenuGroups = (overviewData) => {
  const groups = [];

  overviewData.forEach((data) => {
    groups.push({
      id: data.id,
      category: {
        name: data.category,
        categoryNr: data.categoryNr,
      },
      items: data.subcategories.map((subcategory) => ({
        name: subcategory.name,
        subcategoryNr: subcategory.subcategoryNr,
      })),
    });
  });

  return groups;
};
